import { TApplicationState } from '../../types/redux';

export const selectUser = (state: TApplicationState) => {
  return state.user;
};
